import React from "react";
import Checkbox from "../../../form/Checkbox";
import Image from "../../../elements/Image";
import { lngDetect } from "../../../../helpers/lngDetect";
import dayjs from "dayjs";
import NoData from "../../../elements/Nodata";
import emptyImg from "../../../../assets/images/Empty.svg";

const SelectedEventsList = ({
  selectedEvents = [],
  setSelectedEvents = () => {},
}) => {
  return (
    <div className="flex flex-col h-full w-full">
      {selectedEvents?.length > 0 && (
        <ul className="space-y-2">
          {selectedEvents?.map((event, i) => (
            <li
              onClick={() => {
                setSelectedEvents(event);
              }}
              key={i?.toString()}
              className="group hover:shadow transition-all duration-300 p-3 border border-slate-100 bg-slate-50 rounded-lg flex items-center gap-2"
            >
              <Checkbox
                checked={selectedEvents?.some(
                  (item) => item?._id === event?._id
                )}
              />
              <div className="h-14 min-w-14 w-14 overflow-hidden rounded-lg border border-gray-200">
                {event?.gallery?.[0]?.url && (
                  <Image
                    src={event?.gallery?.[0]?.url}
                    alt={lngDetect(event?.title)}
                    classes={
                      "w-full h-full object-cover object-center group-hover:scale-[1.1] transition-all duration-300"
                    }
                  />
                )}
              </div>
              <div className="overflow-hidden">
                <div className="font-medium text-sm whitespace-nowrap truncate">
                  {lngDetect(event?.title)}
                </div>
                <div className="text-xs flex items-center gap-1">
                  {dayjs(event?.startDate).format("DD MMM YYYY")}
                  <i className="fa-fw fa-regular fa-minus"></i>
                  {dayjs(event?.endDate).format("DD MMM YYYY")}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}

      {selectedEvents?.length === 0 && (
        <div className="my-auto">
          <NoData
            image={emptyImg}
            imageClass={"w-52 h-52"}
            message={<div className="text-lg font-medium">No data found</div>}
          />
        </div>
      )}
    </div>
  );
};

export default SelectedEventsList;
